/*  SECTION-BENEFITS  */

(() => {
    const getSwiperConstructor = () => window.Swiper || window.FoxTheme?.Swiper?.Swiper;

    const initIngredientSwiper = () => {
        const SwiperConstructor = getSwiperConstructor();
        const sliders = document.querySelectorAll('.ingredients-list');

        if (!sliders.length || !SwiperConstructor) {
            return;
        }

        sliders.forEach((slider) => {
            // Evita inicializacao duplicada quando o tema ja criou a instancia.
            if (slider.swiper) {
                return;
            }

          const totalSlides = slider.querySelectorAll('.swiper-slide').length;
          const desktopSlidesPerView = totalSlides >= 4 ? 4 : totalSlides >= 3 ? 3 : Math.max(totalSlides, 1);
            const paginationEl = slider.querySelector('.swiper-pagination');
            const navigationNextEl = slider.querySelector('.swiper-button-next');
            const navigationPrevEl = slider.querySelector('.swiper-button-prev');
            const controlsEl = slider.querySelector('.swiper-controls');
            const modules = [];

            if (window.FoxTheme?.Swiper?.Pagination) {
                modules.push(window.FoxTheme.Swiper.Pagination);
            }

            if (window.FoxTheme?.Swiper?.A11y) {
                modules.push(window.FoxTheme.Swiper.A11y);
            }

            if (window.FoxTheme?.Swiper?.Navigation) {
              modules.push(window.FoxTheme.Swiper.Navigation);
            }

            const swiperInstance = new SwiperConstructor(slider, {
                speed: 400,
                modules,
                slidesPerView: 1,
                spaceBetween: 24,
                watchOverflow: true,
              navigation:
                navigationNextEl && navigationPrevEl
                  ? {
                      nextEl: navigationNextEl,
                      prevEl: navigationPrevEl,
                    }
                  : undefined,
                breakpoints: {
                    767: {
                        slidesPerView: desktopSlidesPerView,
                        spaceBetween: 40,
                        pagination: paginationEl
                            ? {
                                    el: paginationEl,
                                    type: 'bullets',
                                }
                            : undefined,
                    },
                },
            });

                const updateControlsVisibility = () => {
                  if (!controlsEl) return;

                  const currentSlidesPerView =
                    typeof swiperInstance.params.slidesPerView === 'number' ? swiperInstance.params.slidesPerView : 1;
                  const hideControls = totalSlides <= currentSlidesPerView;

                  controlsEl.classList.toggle('hidden', hideControls);
                };

                updateControlsVisibility();
                swiperInstance.on('resize', updateControlsVisibility);
                swiperInstance.on('breakpoint', updateControlsVisibility);
        });
    };

    initIngredientSwiper();

    if (!getSwiperConstructor()) {
        window.addEventListener('load', initIngredientSwiper, { once: true });
    }
})();


/*  SECTION-SIP-OCCASIONS  */

var sipOccasionsSwaper;

(() => {
    const getSwiperConstructor = () => window.Swiper || window.FoxTheme?.Swiper?.Swiper;

    const initSipOccasionsSwiper = () => {
        const slider = document.querySelector('.sip-occasions--slider');
        const SwiperConstructor = getSwiperConstructor();

        if (!slider || !SwiperConstructor || slider.swiper) {
            return;
        }

        const modules = [];

        if (window.FoxTheme?.Swiper?.Autoplay) {
            modules.push(window.FoxTheme.Swiper.Autoplay);
        }

        if (window.FoxTheme?.Swiper?.A11y) {
            modules.push(window.FoxTheme.Swiper.A11y);
        }

        sipOccasionsSwaper = new SwiperConstructor(slider, {
            modules,
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 4000,
            },
            spaceBetween: 0,
        });
    };

    initSipOccasionsSwiper();

    if (!getSwiperConstructor()) {
        window.addEventListener('load', initSipOccasionsSwiper, { once: true });
    }
})();

// BOTANICAL GLOSSARY FILTER
document.addEventListener('DOMContentLoaded', function () {
  if (window.__botanicalGlossaryCustomInit) {
    return;
  }

  var ingredientsGrid = document.getElementById('ingredients_grid');
  var letterFilters = document.querySelectorAll('.letter-filter');

  if (!ingredientsGrid || !letterFilters.length) {
    return;
  }

  window.__botanicalGlossaryCustomInit = true;

  var glossaryItemSelector =
    '#ingredients_grid .ingredients_info__item, #ingredients_grid > .column, #ingredients_grid .column';

  function getGlossaryItems() {
    return Array.from(document.querySelectorAll(glossaryItemSelector));
  }

  function setGridOpacity(value, duration) {
    ingredientsGrid.style.transition = 'opacity ' + duration + 'ms';
    ingredientsGrid.style.opacity = String(value);
  }

  function hideItems(items) {
    items.forEach(function (item) {
      item.style.display = 'none';
    });
  }

  function showItems(items) {
    items.forEach(function (item) {
      item.style.display = '';
    });
  }

  function showAllItems() {
    setGridOpacity(0, 100);

    setTimeout(function () {
      showItems(getGlossaryItems());
      setGridOpacity(1, 300);
    }, 300);
  }

  function filterItemsByLetter(letter) {
    var normalizedLetter = (letter || '').toString().trim().toLowerCase();
    var items = getGlossaryItems();

    if (!normalizedLetter) {
      showAllItems();
      return;
    }

    var matchedItems = items.filter(function (item) {
      var classTokens = (item.className || '').toLowerCase().split(/\s+/);
      return classTokens.indexOf(normalizedLetter) !== -1;
    });

    var hiddenItems = items.filter(function (item) {
      return matchedItems.indexOf(item) === -1;
    });

    hideItems(hiddenItems);
    setGridOpacity(0, 100);

    setTimeout(function () {
      showItems(matchedItems);
      setGridOpacity(1, 300);
    }, 300);
  }

  document.addEventListener('click', function (event) {
    var filter = event.target.closest('.letter-filter:not(.disable)');

    if (!filter) {
      return;
    }

    if (filter.classList.contains('selected')) {
      filter.classList.remove('selected');
      showAllItems();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var selectedLetter = filter.getAttribute('filter-attr');
    var container = filter.closest('ul') || document;

    container.querySelectorAll('.selected').forEach(function (selected) {
      selected.classList.remove('selected');
    });

    filter.classList.add('selected');
    filterItemsByLetter(selectedLetter);
  });

  if (window.location.hash) {
    var activeLetter = window.location.hash.replace('#', '');
    var activeFilter = Array.from(document.querySelectorAll('a.letter-filter')).find(function (link) {
      return link.getAttribute('filter-attr') === activeLetter;
    });

    if (activeFilter) {
      activeFilter.click();
    }

    var glossarySection = document.getElementById('Glossary_Section');

    if (glossarySection) {
      var targetTop = glossarySection.getBoundingClientRect().top + window.scrollY - 200;
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    }
  }
});